import { StapleTable, StapleTableHeading } from '@insurancemenu/imenu-components-lib';
import { styled } from 'styled-components';

export const StapleTableHeadingStyled = styled(StapleTableHeading)`
  text-align: right;

  &:last-child {
    padding-right: 3rem;
  }
`;

export const StapleTableStyled = styled(StapleTable)`
  width: max(100%, 70rem);
`;
